"use client";
import { useState, useContext } from "react";
import classNames from "classnames";


import {
  ResponsiveDrawerDropdown,
  DropdownToggle,
  DropdownItem,
} from "@stadium/ui/src/components/bootstrap-dropdown";
import TextInput from "@stadium/ui/src/components/form/TextInput";
import TextAreaInput from "@stadium/ui/src/components/form/TextAreaInput";
import Button from "@stadium/shared/src/components/shared/button";

import { OtherInputProps } from "@stadium/shared/src/components/book-a-call/form";


import defaultStyles from "./main.module.scss";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

const SingleSelectDropdown = ({
  fieldLabel,
  formValues,
  inputData,
  fieldValue,
  fieldError,
  renderTextArea = false,
  handleFieldChange,
  errorFieldsRef,
  styles = defaultStyles,
}) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const { fieldName, options, placeholderText, otherInput } = inputData;

  const { value: otherValue, other } = formValues[fieldName];
  const otherInputValue = other ? otherValue : "";

  const [showOtherInput, setShowOtherInput] = useState(!!otherInputValue);
  const toggleOtherInput = () => setShowOtherInput(!showOtherInput);

  const [showDropDown, setShowDropDown] = useState(false);
  const toggleDropDown = (isOpen = false) => {
    setShowDropDown(!showDropDown);
    if (!isOpen) {
      setShowOtherInput(!!otherInputValue);
    }
  };

  const renderOtherTextInputOrTextArea = ({
    fieldName,
    otherPlaceHolderText = "Please specify",
    renderTextArea = false,
  }: OtherInputProps) => {
    return (
      <>
        {renderTextArea ? (
          <TextAreaInput
            name={fieldName}
            id={fieldName}
            value={otherInputValue}
            autoFocus
            classes={styles.textAreaInputBlock}
            className={styles.bookCallTextArea}
            inputContainerClass={styles.bookCallTextAreaHolder}
            placeholder={otherPlaceHolderText}
            onChange={({ value }) =>
              handleFieldChange({
                name: fieldName,
                value,
                other: true,
              })
            }
          />
        ) : (
          <TextInput
            name={fieldName}
            id={fieldName}
            value={otherInputValue}
            type="text"
            autoFocus
            classes={`${styles.commonOtherInput} ${styles.otherInput} ${styles.otherInputWithBg}`}
            className={styles.bookCallFormInput}
            inputContainerClass={styles.otherInputContainer}
            placeholder={otherPlaceHolderText}
            onChange={({ value }) =>
              handleFieldChange({
                name: fieldName,
                value,
                other: true,
              })
            }
          />
        )}
        <DropdownItem>
          <Button
            type="button"
            disabled={otherInputValue?.length === 0}
            title="Apply"
            styleType="primary"
            className={styles.btnApply}
          >
            Apply
          </Button>
        </DropdownItem>
      </>
    );
  };

  return (
    <div
      className={`${styles.bookCallFormFieldHolder} ${styles.singleOptionDropdownBlock}`}
      ref={errorFieldsRef.currentSetup}
    >
      <div className={styles.label}>{fieldLabel}</div>
      <div className={styles.bookCallFormResponsiveDropdown}>
        <ResponsiveDrawerDropdown
          show={showDropDown}
          onToggle={toggleDropDown}
          key={fieldName}
          styles={styles}
          menuClassName={styles.dropDownOptions}
          enablePortal={isMobileDevice}
          label={
            <DropdownToggle
              title={fieldName}
              styles={styles}
              truncate
              className={classNames({ [styles.errorBorder]: !!fieldError })}
            >
              {fieldValue ? (
                <span>{fieldValue}</span>
              ) : (
                <div className={styles.placeholderText}>{placeholderText}</div>
              )}
            </DropdownToggle>
          }
          heading={<DropdownToggle>{placeholderText}</DropdownToggle>}
        >
          {options.map(({ title, subTitle }) => (
            <DropdownItem
              styles={styles}
              key={title}
              onSelect={() => handleFieldChange({ name: fieldName, value: title })}
              className={styles.dropDownItemV2 }
              isActive={fieldValue?.includes(title)}
            >
              <div className={styles.dropdownItemTextContainer}>
                <div className={styles.dropdownItemText}>
                  <span>{title}</span>
                  {subTitle && <span className={styles.dropdownItemSubTitle}>{subTitle}</span>}
                </div>
              </div>
            </DropdownItem>
          ))}
          {otherInput?.label && (
            <Button
              type="button"
              styleType="no-style"
              className={`${styles.panelLabel} ${styles.toggleLabel} ${showOtherInput ? styles.activeRow : ""}`}
              onClick={toggleOtherInput}
            >
              {otherInput.label}
            </Button>
          )}
          {showOtherInput &&
            renderOtherTextInputOrTextArea({
              fieldName,
              otherPlaceHolderText: otherInput.placeHolderText,
              renderTextArea,
            })}
        </ResponsiveDrawerDropdown>
      </div>
    </div>
  );
};

export default SingleSelectDropdown;
